<template>
  <footer>
    <div class="friendlinks-wrapper">
      <div class="friendlinks">
        <a href="http://www.geely.com/brandworld" style="">品牌天地</a>
        <ul>
          <li>
            <a href="http://www.zgh.com/zh-hans/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_01')">集团概述</a>
          </li>
          <li>
            <a href="http://www.geely.com/zh-CN/geelynews/newslist" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_36')">新闻资讯</a>
          </li>
          <li>
            <a href="http://intec.geely.com" target="_blank">技术品牌</a>
          </li>
          <li>
            <a href="http://www.geely.com/zh-CN/brandworld#ToCulture" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_02')">企业文化</a>
          </li>
          <li>
            <a href="http://www.geely.com/zh-CN/brandworld#ToEducation" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_04')">吉利教育</a>
          </li>
          <li>
            <a href="http://www.geely.com/zh-CN/brandworld#ToResponsibility" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_03')">社会责任</a>
          </li>
          <li>
            <router-link to="/policy">隐私政策</router-link>
          </li>
        </ul>
      </div>
      <div class="friendlinks">
        <a href="http://www.geely.com/carmodelview/advancedquery" style="">热门车型</a>
        <ul>
          <li>
            <a href="https://br.geely.com/brge" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_08')">博瑞</a>
          </li>
          <li>
            <a href="https://suv.geely.com/boyue/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_09')">博越</a>
          </li>
          <li>
            <a href="https://promotion.geely.com/dhgl/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_10')">帝豪GL</a>
          </li>
          <li>
            <a href="https://promotion.geely.com/dhgs/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_11')">帝豪GS</a>
          </li>
          <li>
            <a href="https://promotion.geely.com/xindihao/car_16.html" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_12')">全新帝豪</a>
          </li>
          <li>
            <a href="https://promotion.geely.com/fc3/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_13')">全新远景</a>
          </li>
        </ul>
      </div>
      <div class="friendlinks">
        <a href="javascript:void(0)" style="cursor: default; text-decoration: none;">购车支持</a>
        <ul>
          <li>
            <a @click="toggleTestDrive" style="cursor: pointer" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_15')">预约试驾</a>
          </li>
          <li>
            <a href="http://www.geely.com/carbuysupport/dealerqueryamap" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_17')">经销商查询</a>
          </li>
          <li>
            <a href="http://www.geely.com/carbuysupport/activecenter" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_18')">市场活动</a>
          </li>
          <li>
            <a href="http://geely.tmall.com/" style="" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_19')">天猫旗舰店</a>
          </li>
        </ul>
      </div>
      <div class="friendlinks">
        <a style="cursor: default; text-decoration: none;">车主服务</a>
        <ul>
          <li>
            <a href="http://www.geely.com/carservice#ToService" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_23')">服务活动</a>
          </li>
          <li>
            <a href="http://www.geely.com/carservice/classroom" target="">关爱课堂</a>
          </li>
          <li>
            <a href="http://www.geely.com/carservice/serviceintroduce" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_24')">服务介绍</a>
          </li>
          <li>
            <a href="http://www.geely.com/carservice/servicestationamap" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_22')">服务站查询</a>
          </li>
          <li v-if="1 > 2">
            <a href="http://mall.geely.com/index.php/fitting" target="_blank">精品与零件</a>
          </li>
          <li>
            <a href="http://user.zjcarnet.com/" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_20')">G-LINK服务</a>
          </li>
        </ul>
      </div>
      <div class="friendlinks">
        <a href="javascript:void(0)" style="cursor: default; text-decoration: none;">商务合作</a>
        <ul>
          <li>
            <a href="http://visit.geely.com/home/order" style="" data-parent="商务合作" data-text="吉利研发中心预约" target="_blank">吉利研发中心预约</a>
          </li>
          <li>
            <a href="http://www.geely.com/zh-CN/joinus/merchantsjoining/GeelyCarJoin" style="" target="" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_34')">吉利汽车招商加盟</a>
          </li>
          <li>
            <a href="http://promotion.geely.com/xny/joinus.html" style="" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_35')">吉利新能源招商加盟</a>
          </li>
          <li>
            <a href="https://zb.geely.com/gap/" style="" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_FOOTER_07')">吉利招标采购平台</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright-wrapper">
      <div class="copyright">
        <p>© 2013 浙江吉利控股集团有限公司 版权所有 <a style="color:#fff" href="http://www.beian.miit.gov.cn" target="_blank">浙ICP备11045738号</a></p>
        <p>
          <img src="https://dm30-dev.obs.myhwclouds.com/GeelyOfficial/Files/Common/Footer/logo.png"> 中国互联网诚信示范单位
        </p>
        <div class="copyright-other phs">
          <a class="phone" href="javascript:void(0)">
            <i class="glfico-ic_phone_in_talk"></i>
            <span>400-886-9888</span>
          </a>
        </div>
      </div>
      <div class="copyright-other">
        <a class="phone phh" href="javascript:void(0)" style="cursor:text">
          <i class="glfico-ic_phone_in_talk"></i>
          <span>
                    400-886-9888
                </span>
        </a>
        <div class="quick-links phs">
          <span class="fenxiang phs">分享：</span>
          <a :href="weiboShareUrl" target="_blank">
            <i class="glfico-weibo"></i>
          </a>
          <a @click="mask = !mask">
            <i class="glfico-wechat"></i>
          </a>
          <a :href="qqShareUrl" target="_blank">
            <i class="glfico-qq"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="wx-share-box" id="wx_share_footer" v-if="mask">
      <div class="title">
        <span>分享到微信朋友圈</span>
        <span class="close" @click="mask = !mask">
            <i class="glfico-close1"></i>
        </span>
      </div>
      <div class="body">
        <img id="wx_share_image" src="@/assets/images/createqrcode.gif" />
      </div>
      <div class="footer">
        打开微信，点击底部的“发现”，使用 “扫一扫” 即可将网页分享到我的朋友圈。 如何使用？
      </div>
    </div>
    <div class="mask" v-if="mask" @click="mask = !mask"></div>
  </footer>
</template>
<script>
  export default {
    name: 'Footer',
    data() {
      return {
        mask: false,
        weiboShareUrl: '',
        qqShareUrl: ''
      }
    },
    methods: {
      toggleTestDrive() {
        this.$store.dispatch('toggleTestDrive');
      }
    },
    created() {
      const weiboTitle = '浙江吉利汽车有限公司%20浙江吉利控股集团始建于1986年，1997年进入汽车行业，一直专注实业，专注技术创新和人才培养，不断打基础练内功，坚定不移地推动企业健康可持续发展。现资产总值超过2000亿元，员工总数超过7万多人，连续六年进入世界500强。';
      const weiboKey = '2992571369';
      const originUrl = window.location.origin;
      this.weiboShareUrl = `http://service.weibo.com/share/share.php?appkey=${weiboKey}&title=${weiboTitle}&url=${originUrl}&searchPic=false&style=simple`;
      const qqDesc = '浙江吉利汽车有限公司%20浙江吉利控股集团始建于1986年，1997年进入汽车行业，一直专注实业，专注技术创新和人才培养，不断打基础练内功，坚定不移地推动企业健康可持续发展。现资产总值超过2000亿元，员工总数超过7万多人，连续六年进入世界500强。';
      const qqSummary = '浙江吉利汽车有限公司%20浙江吉利控股集团始建于1986年，1997年进入汽车行业，一直专注实业，专注技术创新和人才培养，不断打基础练内功，坚定不移地推动企业健康可持续发展。现资产总值超过2000亿元，员工总数超过7万多人，连续六年进入世界500强。';
      const qqTitle = '浙江吉利汽车有限公司';
      this.qqShareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${originUrl}&title=${qqTitle}&showcount=0&summary=${qqSummary}&desc=${qqDesc}`;
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->


<style scoped lang="less">
  @import '../../../static/glficofont/glfico.less';

  footer {
    background-color: rgb(5, 90, 148);
    padding: 0.2rem 13% 0.2rem 13%;
    .friendlinks-wrapper {
      display: flex;
      flex-wrap: wrap;
      .friendlinks {
        //width:11.625%;
        width: calc(96% / 5);
        padding-left: 0.02rem;
        > a {
          color: #acd8f1;
          font-size: 0.2rem;
          cursor:pointer;
        }
        > ul {
          margin-top: .08rem;
          > li {
            > a {
              color: #FFF;
              font-size: 0.17rem;
            }
            & + li {
              margin-top: 0.03rem;
            }
          }
        }
        & + .friendlinks {
          margin-left: 1%;
        }
      }
    }
    .copyright-wrapper {
      margin-top: 0.15rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .copyright {
        color: #FFF;
        padding-left: 0.02rem;
        p {
          font-size: 0.15rem;
          margin-bottom: 0;
        }
        img {
          height: 0.25rem;
        }
      }
      .copyright-other {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &.phs {
          display: none;
        }
        .phone {
          display: block;
          text-decoration: none;
          color: #FFF;
          font-size: 0.28rem;
          &.phh {
            //display:none;
          }
          > i {
            font-size: 0.32rem;
          }
        }
        .quick-links {
          margin-top: .1rem;
          .fenxiang {
            display: none;
          }
          > a {
            display: inline-flex;
            height: 0.53rem;
            width: 0.53rem;
            border-radius: .054rem;
            background-color: rgba(0, 0, 0, .4);
            color: #FFF;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            position: relative;
            text-decoration: none;
            > i {
              font-size: 0.32rem;
              color: #FFF;
            }
            & + a {
              margin-left: 0.01rem;
            }
          }
        }
      }
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 6;
  }
  .wx-share-box {
    width: 3rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    background: #FFF;
    box-shadow: 0 0.03rem 0.07rem rgba(0, 0, 0, 0.3);
    border-radius: 0.04rem;
    z-index: 201;
    transition: transform .3s cubic-bezier(.175, .885, .32, 1.275), opacity .3s;
    .title {
      padding: 0.2rem;
      border-bottom: 1px solid #F0F0F0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .close {
        > i {
          display: block;
          font-size: 0.015rem;
        }
      }
    }
    .body {
      height: 3rem;
      padding: 0.1rem 0.2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .footer {
      padding: 0.2rem;
      border-top: 1px solid #F0F0F0;
    }
    &.active {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  @media screen and (max-width: 812px) {
    html.friendlinks-open {
      height: 100%;
      overflow: hidden;
      body {
        height: 100%;
        overflow: hidden;
        .mask {
          z-index: 201;
        }
      }
    }

    footer {
      //padding:2rem 8%;
      padding: 0.02rem 0;
      .friendlinks-wrapper {
        flex-wrap: wrap;
        .friendlinks {
          width: 49.5%;
          text-align: center;
          padding-left: 0;
          > a {
            &:after {
              content: ">";
              margin-left: 0.01rem;
            }
          }
          > ul {
            position: fixed;
            margin-top: 0;
            left: 0;
            bottom: -80vh;
            opacity: 0;
            width: 100vw;
            height: auto;
            z-index: 202;
            transition: all .5s ease-in-out;
            box-shadow: -2px 0 0 rgba(0, 0, 0, 0.2);
            background-color: #FFF;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding: 0.01rem;
            > li {
              display: block;
              border-bottom: 1px solid #F0F0F0;
              padding-bottom: .008rem;
              > a {
                font-size: 0.015rem;
                color: #888;
              }
              & + li {
                margin-top: .008rem;
              }
            }
          }
          & + .friendlinks {
            margin-left: 0;
          }
          &:nth-child(2n+2) {
            margin-left: 1%;
          }
          &:nth-child(2n+3) {
            margin-top: 0.001rem;
          }
          &:nth-child(2n+4) {
            margin-top: 0.001rem;
          }
          &.active {
            > ul {
              opacity: 1;
              bottom: 0;
            }
          }
        }
      }
      .copyright-wrapper {
        flex-direction: column-reverse;
        align-items: center;
        .copyright-other {
          width: 75%;
          &.phs {
            display: flex;
            margin-top: 0.001rem;
            width: 100%;
            .phone {
              font-size: 0.2rem;
              > i {
                font-size: 0.012rem;
              }
            }
          }
          .phone.phh {
            display: none;
          }
          .quick-links {
            display: flex;
            justify-content: space-around;
            .fenxiang {
              display: inline-block;
              vertical-align: top;
              color: #fff;
              line-height: 0.03rem;
              font-size: 0.014rem;
            }
            > a {
              background-color: rgba(0, 0, 0, 0, 0);
              margin: 0 0.004rem;
            }
          }
        }
        .quick-links {
          width: 100%;
          text-align: center;
          > a {
            //background-color:transparent;
            background-color: rgba(0, 0, 0, 0, 0);
          }
        }
        .copyright {
          width: 100%;
          text-align: center;
          //margin-top:.5rem;
          margin-top: 0.01rem;
          padding-left: 0;
        }
      }
    }
  }

  @media screen and (max-width: 375px) {
    .fourth-page .news-blocks-wrapper .news-blocks .news-block .more {
      top: calc(20vh + 0.06rem);
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/common/Foot.vue